module.exports = __webpack_public_path__ + "static/media/catoffline_small.1b9ebd73.jpg";